import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { ErrorCodeEnum } from '../shared/const/enum';
import { Constants } from '../shared/const/constant';
import { UtilService } from './util.service';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class HttpExceptionInterceptor implements HttpInterceptor {

  private utilService = inject(UtilService);
  private authService = inject(AuthService);
  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(map(response => response), catchError((exception: any) => {
      const serverMessage = exception?.error?.message;
      switch (exception.status) {
        case ErrorCodeEnum.BadRequest:
        case ErrorCodeEnum.InvalidRequest:
          if (serverMessage) {
            this.utilService.showWarnMessage(serverMessage);
          }
          break;
        case ErrorCodeEnum.Unauthorized:
          if (serverMessage) {
            this.utilService.showWarnMessage(serverMessage);
          }
          /**
           * Only this platform's own API can end the session.
           *
           * A 401 from anywhere else says something about that service, not about the operator's
           * login — and the media service is a separate origin with its own token verification, so
           * a misconfigured JWT_SECRET there was logging people out of the dashboard every time
           * they opened Live. The error still propagates; it just no longer costs a session.
           */
          if (this.isPlatformApi(request.url)) {
            this.authService.logout();
          }
          break;
        default:
          break;
      }
      console.error('[http]', exception?.status, request.method, request.url, exception?.message);
      return throwError(() => exception);
    }));
  }

  /** Whether a url belongs to this platform's API, as opposed to a separate service it calls. */
  private isPlatformApi(url: string): boolean {
    try {
      const target = new URL(url, window.location.origin).origin;
      return target === new URL(environment.apiUrl, window.location.origin).origin;
    } catch {
      // A relative or malformed url can only be our own.
      return true;
    }
  }
}

// intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
//   return next.handle(request).pipe(map(response => response), catchError((exception: any) => {
//     switch (exception.status) {
//       case ErrorCodeEnum.Unknown:
//         this.utilService.showErrorMessage(Constants.errorMessage0);
//         break;
//       case ErrorCodeEnum.BadRequest:
//       case ErrorCodeEnum.InvalidRequest:
//         if (exception.error.message) {
//           this.utilService.showWarnMessage(exception.error.message);
//         } else {
//           this.utilService.showErrorMessage(Constants.errorMessage400);
//         }
//         break;
//       case ErrorCodeEnum.Unauthorized:
//         if (exception.error.message) {
//           this.utilService.showWarnMessage(exception.error.message);
//         } else {
//           this.utilService.showErrorMessage(Constants.errorMessage401);
//         }
//         this.authService.logout();
//         break;
//       case ErrorCodeEnum.NotFound:
//         this.utilService.showErrorMessage(Constants.errorMessage404);
//         break;
//       case ErrorCodeEnum.InternalServerError:
//         this.utilService.showErrorMessage(Constants.errorMessage500);
//         break;
//       default:
//         this.utilService.showErrorMessage(Constants.msgApiError);
//         break;
//     }
//     return throwError(() => exception);
//   }));
// }